import { Platform } from 'react-native';
import React, { useEffect } from 'react';

import { OrderContainer } from '@components/OrderView';
import { OrderErrorBoundary } from '@components/OrderErrorBoundary';
import { ScreenContent } from '@components/ScreenContent';
import { Typography } from '@components/Typography';
import { crashlyticsUtil } from '@lib/crashlytics';
import { logger } from '@lib/logger';
import { updateOrderStatus } from '@lib/api/updateOrderStatus';
import { useNewOrder } from '@stores';
import { useParams } from '@hooks';

export const NewOrderScreen: React.FC = () => {
  const { params } = useParams<'NewOrder'>();
  const { order } = useNewOrder(params.id);

  useEffect(() => {
    if (Platform.OS !== 'web') {
      crashlyticsUtil.log(`User viewed NewOrderScreen for Order ID: ${params.id}`);
      crashlyticsUtil.setAttribute('viewed_order_uuid', params.id);
    }

    const setOrderAsSeen = async () => {
      try {
        await updateOrderStatus({
          requestType: 'SET_ORDER_AS_SEEN',
          time: Date.now(),
          ordersUUIDs: [params.id],
        });
      } catch (error) {
        logger.error('error', error);
        crashlyticsUtil.setAttribute('api_error_context', 'SET_ORDER_AS_SEEN_FAILURE');
        crashlyticsUtil.recordError(
          error instanceof Error ? error : new Error(JSON.stringify(error))
        );
      }
    };

    setOrderAsSeen();
  }, [params.id]);

  return (
    <ScreenContent>
      {order && order.uuid ? (
        <OrderErrorBoundary orderUUID={order.uuid}>
          <OrderContainer orderUUID={order.uuid} isHistoryOrderFlag={false} />
        </OrderErrorBoundary>
      ) : (
        <Typography>Order with id # {params.id} is no longer new</Typography>
      )}
    </ScreenContent>
  );
};
